import type { ComponentProps } from 'react';

const AvatarMale = (props: ComponentProps<'svg'>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31.9998 61.3332C48.2002 61.3332 61.3332 48.2002 61.3332 31.9998C61.3332 15.7995 48.2002 2.6665 31.9998 2.6665C15.7995 2.6665 2.6665 15.7995 2.6665 31.9998C2.6665 48.2002 15.7995 61.3332 31.9998 61.3332Z"
      fill="#ECF7F6"
    />
    <mask
      id="mask0_208_43411"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="60"
      height="60"
    >
      <path
        d="M31.9998 61.3332C48.2002 61.3332 61.3332 48.2002 61.3332 31.9998C61.3332 15.7995 48.2002 2.6665 31.9998 2.6665C15.7995 2.6665 2.6665 15.7995 2.6665 31.9998C2.6665 48.2002 15.7995 61.3332 31.9998 61.3332Z"
        fill="#ECF7F6"
      />
    </mask>
    <g mask="url(#mask0_208_43411)">
      <path
        d="M33.5977 45.5476H29.0698C23.8814 45.5476 19.6748 41.341 19.6748 36.1526V23.8838C19.6748 18.6954 23.8814 14.4888 29.0698 14.4888H33.5977C38.7861 14.4888 42.9927 18.6954 42.9927 23.8838V36.1526C42.9927 41.341 38.7861 45.5476 33.5977 45.5476Z"
        fill="#FFBF9F"
      />
      <path
        d="M19.6675 29.8636V23.8779C19.6675 18.6895 23.8741 14.4829 29.0625 14.4829H33.5904C38.7788 14.4829 42.9854 18.6895 42.9854 23.8779V29.8636L25.4211 21.5991L19.6675 29.8636Z"
        fill="#263F43"
      />
      <path
        d="M18.2878 36.5155C20.243 36.5155 21.828 34.9305 21.828 32.9753C21.828 31.0201 20.243 29.4351 18.2878 29.4351C16.3326 29.4351 14.7476 31.0201 14.7476 32.9753C14.7476 34.9305 16.3326 36.5155 18.2878 36.5155Z"
        fill="#FFBF9F"
      />
      <path
        d="M44.3962 36.5155C46.3514 36.5155 47.9364 34.9305 47.9364 32.9753C47.9364 31.0201 46.3514 29.4351 44.3962 29.4351C42.441 29.4351 40.856 31.0201 40.856 32.9753C40.856 34.9305 42.441 36.5155 44.3962 36.5155Z"
        fill="#FFBF9F"
      />
      <path
        d="M37.6599 33.7135C38.2875 33.7135 38.7963 32.9144 38.7963 31.9285C38.7963 30.9427 38.2875 30.1436 37.6599 30.1436C37.0322 30.1436 36.5234 30.9427 36.5234 31.9285C36.5234 32.9144 37.0322 33.7135 37.6599 33.7135Z"
        fill="#263F43"
      />
      <path
        d="M25.1525 33.7135C25.7802 33.7135 26.289 32.9144 26.289 31.9285C26.289 30.9427 25.7802 30.1436 25.1525 30.1436C24.5249 30.1436 24.0161 30.9427 24.0161 31.9285C24.0161 32.9144 24.5249 33.7135 25.1525 33.7135Z"
        fill="#263F43"
      />
      <path
        d="M66.9459 95.6525H-2.94238L-2.94238 64.0641C-2.94238 55.0083 4.39988 47.666 13.4557 47.666H50.5478C59.6037 47.666 66.9459 55.0083 66.9459 64.0641V95.6525Z"
        fill="#5BAFA9"
      />
      <mask
        id="mask1_208_43411"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-3"
        y="47"
        width="70"
        height="49"
      >
        <path
          d="M66.9459 95.6525H-2.94238L-2.94238 64.0641C-2.94238 55.0083 4.39988 47.666 13.4557 47.666H50.5478C59.6037 47.666 66.9459 55.0083 66.9459 64.0641V95.6525Z"
          fill="#5BAFA9"
        />
      </mask>
      <g mask="url(#mask1_208_43411)">
        <path
          d="M32.001 56.6563L42.7169 54.1335L37.0346 44.209L32.001 56.6563Z"
          fill="#4F9493"
        />
        <path
          d="M32.0015 56.6563L21.6069 53.5683L26.9679 44.209L32.0015 56.6563Z"
          fill="#4F9493"
        />
        <path
          d="M32.0008 56.6564L43.5021 33.8442H20.4995L32.0008 56.6564Z"
          fill="#FFBF9F"
        />
      </g>
      <path
        d="M36.1912 35.4985L31.4907 38.6401C31.4907 38.6401 33.3769 41.2819 35.733 39.6695C37.9881 38.1165 36.1912 35.4985 36.1912 35.4985Z"
        fill="white"
      />
      <path
        d="M29.9616 29.6494V34.3678C29.9616 34.3678 28.004 33.7549 28.2599 35.0044C28.5157 36.2539 29.9616 36.8727 29.9616 36.8727"
        stroke="#263F43"
        strokeWidth="0.89511"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default AvatarMale;
